'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var axios = _interopDefault(require('axios'));
var md5 = _interopDefault(require('js-md5'));
var querystring = _interopDefault(require('query-string'));

var objectToString = Object.prototype.toString;
var toTypeString = function toTypeString(val) {
  return objectToString.call(val);
};
var isPlainObject = function isPlainObject(val) {
  return toTypeString(val) === '[object Object]';
};

/*
 * @Descripttion:
 * @version:
 * @Author: shenjia
 * @Date: 2020-09-11 14:26:34
 * @LastEditors: shenjia
 * @LastEditTime: 2020-09-14 09:59:20
 */

(function () {
  var generateRandom = function generateRandom(len) {
    var chars = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '0123456789';
    var randomStr = '';

    for (var i = 0; i < len; i++) {
      randomStr += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    return randomStr;
  }; // 默认添加一个


  window.FX_RANDOM = generateRandom(32);
  document.addEventListener('click', function () {
    window.FX_RANDOM = generateRandom(32);
  });
})();

var trackLog = function trackLog(eventName, eventProperty) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    buisness: 'h5'
  };

  if (!isPlainObject(eventProperty)) {
    eventProperty = {};
  }

  var _location = location,
      origin = _location.origin,
      pathname = _location.pathname,
      search = _location.search,
      host = _location.host,
      port = _location.port;

  var _querystring$parse = querystring.parse(search),
      _querystring$parse$pl = _querystring$parse.platform,
      platform = _querystring$parse$pl === void 0 ? '' : _querystring$parse$pl,
      _querystring$parse$ui = _querystring$parse.uid,
      uid = _querystring$parse$ui === void 0 ? '' : _querystring$parse$ui,
      _querystring$parse$v = _querystring$parse.v,
      v = _querystring$parse$v === void 0 ? '' : _querystring$parse$v,
      _querystring$parse$le = _querystring$parse.level,
      level = _querystring$parse$le === void 0 ? '' : _querystring$parse$le,
      _querystring$parse$tr = _querystring$parse.traFromId,
      traFromId = _querystring$parse$tr === void 0 ? '' : _querystring$parse$tr;

  var logstore = "".concat(options.buisness, "-prod");

  if (host === 'front-test.fenxianglife.com' || port && port !== '80') {
    logstore = "".concat(options.buisness === 'h5' ? 'mobile' : options.buisness, "-test");
  }

  eventProperty = Object.assign({}, eventProperty, {
    page_url: "".concat(origin).concat(pathname),
    page_title: document.title
  });
  var params = {
    level: level,
    eventName: eventName,
    platform: platform,
    traFromId: traFromId,
    appVer: v,
    APIVersion: '0.6.0',
    timestamp: Date.now(),
    eventType: eventProperty,
    umid: uid ? md5('' + uid) : uid,
    to: window.FX_RANDOM || ''
  };

  if (eventProperty.hasOwnProperty('level')) {
    params.level = eventProperty.level || '';
    delete eventProperty.level;
  }

  axios.get("https://mobile-data-acquisition.cn-hangzhou.log.aliyuncs.com/logstores/".concat(logstore, "/track"), {
    params: params
  }).then(function () {
    console.log(JSON.stringify(params, null, 2));
  });
};

exports.trackLog = trackLog;
